/**
 * Autofill input values in the form, and execute the query
 */
export default function autofill(form, update = () => null) {
  const autofill = JSON.parse(form.getAttribute('data-autofill'));
  let autofilled = false;

  Object.keys(autofill).forEach(k => {
    const v = autofill[k];

    form[k].value = v;
    autofilled = true;
  });

  if (autofilled) {
    update();
  }
}
